module.exports = __webpack_public_path__ + "img/badge-stripe-verified.bbaf134b.svg";